/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop